// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"63a68e15","214":"8e274cf7","352":"9795e2cc","419":"38c9851a","749":"3af3df4a","787":"23455a43"}[chunkId] + ".chunk.js";
};